import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { isBefore, isAfter } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { RootState } from '../configs/store';

export default function useCheckDatetime(prop: any) {
  const [show, setShow] = useState(false);
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);

  useEffect(() => {
    if (prop?.showOptions?.from && isBefore(utcToZonedTime(prop?.showOptions?.from, selectedTimezone), new Date())
      || !prop?.showOptions?.from) setShow(true);
    else if (prop?.showOptions?.to && isAfter(utcToZonedTime(prop?.showOptions?.to, selectedTimezone), new Date())
      || !prop.showOptions?.to) setShow(true);
  }, [prop, selectedTimezone]);

  return show;
}
